import {Text, View} from '@react-pdf/renderer';
import styles from '../styles';
import {IRiskFactor} from '../types';

const ScoreFactorsSection: React.FC<{rows: IRiskFactor[]}> = ({rows}) => (
  <View wrap={false} style={styles.scoreTableWrap}>
    <View style={styles.scoreTableHeaderRow}>
      <Text style={styles.scoreTableHeaderCellTitle}>شاخص های امتیازدهی</Text>
      <Text style={styles.scoreTableHeaderCellScore}>امتیاز</Text>
    </View>

    {rows.map(row => (
      <View key={row.title} style={styles.scoreRow} wrap={false}>
        <View style={styles.scoreCellTitleWrap}>
          <Text style={styles.scoreCellTitle}>{row.title}</Text>
          <View style={{flex: 1, marginRight: 10}}>
            <View style={styles.bulletRow}>
              <Text style={styles.bulletText}>: شامل موارد زیر است</Text>
            </View>
            {row.bullets.map((b, i) => (
              <View style={styles.bulletRow} key={i}>
                <Text style={styles.bulletDot}>•</Text>
                <Text style={styles.bulletText}>{b}</Text>
              </View>
            ))}
          </View>
        </View>
        <View style={styles.scoreCellScoreWrap}>
          <Text style={styles.scoreCellScore}>{row.score}</Text>
        </View>
      </View>
    ))}
  </View>
);

export default ScoreFactorsSection;
